import React from 'react';
import { DialogBody, DialogStyled } from './index.styles';
import { TDialog } from './index.types';

const DialogImage: React.FC<TDialog> = ({
                                          className,
                                          isDialogOpen,
                                          setIsDialogOpen,
                                          children,
                                        }) => {
  return (
    <DialogStyled
      className={className}
      onClose={() => setIsDialogOpen(false)}
      aria-labelledby="dialog"
      open={isDialogOpen}
    >
      <DialogBody>{children}</DialogBody>
    </DialogStyled>
  );
};

export default DialogImage;
